<template>
  <el-tabs type="border-card">
    <el-tab-pane label="托运人资料">
      <shipmentAdd :parent-data="parentData" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import shipmentAdd from "./components/shipmentAdd.vue";
export default {
  name: "AddShipmentForm",
  components: { shipmentAdd },
  data() {
    return {
      parentData: {
        areaOptions: this.$store.state.components.areaOptions,
        isCompany: false
      }
    };
  },
  created() {}
};
</script>
